import React from 'react';
import { Pagination } from 'antd';

const  MiniPaginationCustom = ({color, ...rest}) => (
    <div className={`mini-pagination-custom ${color ? color : ''}`}>
        <Pagination 
            size="small" 
            {...rest}
        />
    </div>
);

export default MiniPaginationCustom ;
